import lottie from 'lottie-web';
import * as locomotive from './locomotive';

export default (node) => {
    const json = node.dataset.json;
    const is_input = node.hasAttribute('data-input');
    const input = node.querySelector('input');

    if (!json) return;

    var animation = lottie.loadAnimation({
        container: node,
        renderer: "svg",
        autoplay: false,
        path: json,
    });

    animation.loop = false;

    if (!is_input) {
        // intro
        node.addEventListener("mouseenter", function () {
            animation.goToAndPlay("intro", false);
            animation.loop = false;

            // loop
            animation.addEventListener('complete', () => {
                animation.removeEventListener('complete');
                animation.goToAndPlay("loop", false);
                animation.loop = true;
            });

            // outro

            if (!is_input) {
                node.addEventListener('mouseleave', () => {
                    animation.loop = false;

                    animation.addEventListener('complete', () => {
                        animation.removeEventListener('complete');
                        animation.goToAndPlay("outro", false);
                        animation.loop = false;
                    });
                }, {once: true});
            }

        });
    }

    if (is_input) {

        input.addEventListener('change', () => {
            if (input.checked) {
                animation.goToAndPlay("intro", false);
                animation.loop = false;
                return;
            }

            animation.goToAndPlay("outro", false);
            animation.loop = false;
        })
    }


    animation.addEventListener('DOMLoaded', function(e) { 
        locomotive.update();

        if (is_input) {
            if (input.checked) {
                animation.goToAndPlay("intro", true);
                animation.loop = false;
            }
        }
    });
};